import Vue from 'vue'

export default el => new Vue({
  name: 'Testimonials',
  el
})
